import { ShareRow } from "@/components/share-row";

/**
 * Awareness is the actual intervention here (most people have never heard of
 * alpha-gal syndrome), so sharing earns a line on the page. Just a line.
 */
export function HomeShareCta() {
  return (
    <section className="mx-auto max-w-6xl px-4 pb-4 sm:px-6">
      <h2 className="label-caps border-t border-rule pt-3 text-muted-foreground">Pass it on</h2>
      <div className="mt-4 max-w-3xl">
        <p className="font-display text-xl leading-snug text-foreground">
          Most people have never heard of alpha-gal syndrome. Send this to someone who hikes, hunts,
          gardens or walks a dog.
        </p>
        <ShareRow path="/" className="mt-4" />
      </div>
    </section>
  );
}
